
export type AISearchRAGCitation = {
    rag_index: string
    content: string
    filepath: string
    page: string | null | undefined
    score: number | null | undefined
}

export type WebSearchCitation = {
    url: string
    title: string
    text: string
}

export type Citation = AISearchRAGCitation | WebSearchCitation

export type AISearchRAGCitation_Parsed = AISearchRAGCitation & {
    title: string
    url: string
    part?: number
}

export type WebSearchCitation_Parsed = WebSearchCitation

export type Citation_Parsed = AISearchRAGCitation_Parsed | WebSearchCitation_Parsed

// AISearchRAGCitationかどうかを判定する関数
export function isAISearchRAGCitation(citation: Citation): citation is AISearchRAGCitation {
    return 'rag_index' in citation && 'content' in citation && 'filepath' in citation;
}

// WebSearchCitationかどうかを判定する関数
export function isWebSearchCitation(citation: Citation): citation is WebSearchCitation {
    return 'url' in citation && 'title' in citation && 'text' in citation;
}

// AISearchRAGCitation_Parsedかどうかを判定する関数
export function isAISearchRAGCitationParsed(citation: Citation_Parsed): citation is AISearchRAGCitation_Parsed {
    return 'rag_index' in citation && 'content' in citation && 'filepath' in citation;
}

// WebSearchCitation_Parsedかどうかを判定する関数
export function isWebSearchCitationParsed(citation: Citation_Parsed): citation is WebSearchCitation_Parsed {
    return 'url' in citation && 'title' in citation && 'text' in citation && !('rag_index' in citation);
}